import endpoints from "../../../Helpers/Endpoints";

// The supplier index is browsed by what the manager is looking for — someone to
// do a job, a shop to order from, a restaurant to feed an event. Each of those
// is its own catalog with its own category tree, so each is its own tab with
// its own filters; a manager never mixes them in one search.
//
// Adding a vertical later means adding an entry here: the tabs scroll, and
// every tab renders from this list.

export const SUPPLIER_ITEM_TYPES = [
  {
    // Services lead — they are the bulk of the index today.
    key: "service",
    labelKey: "tabs.services",
    emptyKey: "empty.services",
    categoriesEndpoint: endpoints.getAllCategories,
    categoriesNamespace: "categories",
  },
  {
    key: "product",
    labelKey: "tabs.stores",
    emptyKey: "empty.stores",
    categoriesEndpoint: endpoints.getSupplierIndexCategories("product"),
    categoriesNamespace: "products_categories",
  },
  {
    key: "restaurant",
    labelKey: "tabs.restaurants",
    emptyKey: "empty.restaurants",
    categoriesEndpoint: endpoints.getSupplierIndexCategories("restaurant"),
    categoriesNamespace: "restaurants_categories",
  },
];

export const DEFAULT_ITEM_TYPE = SUPPLIER_ITEM_TYPES[0].key;

export const itemTypeConfig = (key) =>
  SUPPLIER_ITEM_TYPES.find((type) => type.key === key) || SUPPLIER_ITEM_TYPES[0];
